import styled, { css } from 'styled-components';
import { CNDStyledTextSpan } from '../../../pages/shared/CIPage/ui';

const LegalText = styled(CNDStyledTextSpan)<{ isBefore?: boolean }>`
    ${props => css`
        & p {
            cursor: pointer;
            padding-left: 36px;
            padding-top: ${props.isBefore ? '2px' : '18px'};
            padding-bottom: ${props.isBefore ? '16px' : '0px'};
        }
    `}
`;

export default LegalText;
